export const MatchupHeaderSkeleton = () => {
	return (
		<div className="flex flex-col w-full animate-pulse">
			{/* Back button */}
			<div className="mb-2 sm:mb-6 flex h-6 items-center gap-2">
				<div className="w-5 h-5 bg-gray-300 rounded" />
				<div className="h-4 w-32 bg-gray-300 rounded" />
			</div>

			{/* Matchup header info + actions */}
			<div className="flex justify-between items-center bg-[#FEFAF5] rounded-t-lg p-4 border border-orange-50">
				{/* Matchup info */}
				<div className="flex flex-col gap-2">
					<div className="flex items-center gap-2">
						<div className="w-2 h-2 bg-gray-300 rounded-full" />
						<div className="h-3 w-20 bg-gray-300 rounded" />
					</div>
					<div className="h-4 w-32 bg-gray-300 rounded" />
					<div className="flex items-center gap-2">
						<div className="w-4 h-4 bg-gray-300 rounded" />
						<div className="h-3 w-24 bg-gray-300 rounded" />
					</div>
					<div className="h-3 w-20 bg-gray-300 rounded" />
				</div>

				{/* Matchup buttons */}
				<div className="flex flex-col gap-2">
					<div className="h-8 w-28 bg-gray-300 rounded" />
					<div className="h-8 w-28 bg-gray-300 rounded" />
				</div>
			</div>

			{/* FlagsBanner skeleton */}
			<div className="w-full border-t-2 border-orange-500 flex flex-col sm:flex-row gap-6">
				{/* Away team */}
				<div className="hidden sm:flex flex-col items-end gap-2 flex-1 pt-4">
					<div className="w-24 h-12 md:w-40 md:h-20 bg-gray-300 rounded" />
					<div className="flex flex-col items-end gap-1">
						<div className="h-4 w-24 bg-gray-300 rounded" />
						<div className="flex gap-2">
							<div className="h-3 w-8 bg-gray-300 rounded" />
							<div className="h-3 w-12 bg-gray-300 rounded" />
						</div>
						<div className="h-3 w-16 bg-gray-300 rounded" />
					</div>
				</div>

				{/* Center */}
				<div className="flex self-center sm:self-start">
					<div
						className="w-14 h-20 md:w-20 md:h-28 bg-gray-300 flex items-center justify-center text-white text-4xl font-bold"
						style={{
							clipPath: 'polygon(0 0, 100% 0, 100% 100%, 50% 90%, 0 100%)'
						}}
					/>
					<div className="w-12 h-20 md:w-16 md:h-28 bg-gray-300 flex items-center justify-center text-white text-sm">VS</div>
					<div
						className="w-14 h-20 md:w-20 md:h-28 bg-gray-300 flex items-center justify-center text-white text-4xl font-bold"
						style={{
							clipPath: 'polygon(0 0, 100% 0, 100% 100%, 50% 90%, 0 100%)'
						}}
					/>
				</div>

				{/* Home team */}
				<div className="hidden sm:flex flex-col items-start gap-2 flex-1 pt-4">
					<div className="w-24 h-12 md:w-40 md:h-20 bg-gray-300 rounded" />
					<div className="flex flex-col items-start gap-1">
						<div className="h-4 w-24 bg-gray-300 rounded" />
						<div className="flex gap-2">
							<div className="h-3 w-8 bg-gray-300 rounded" />
							<div className="h-3 w-12 bg-gray-300 rounded" />
						</div>
						<div className="h-3 w-16 bg-gray-300 rounded" />
					</div>
				</div>
			</div>

			{/* Action Buttons */}
			<div className="w-full sm:w-40 self-end mt-4 flex flex-col gap-3">
				<div className="h-10 bg-gray-300 rounded" />
				<div className="h-10 bg-gray-300 rounded" />
			</div>
		</div>
	);
};
